import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  class: "w-full h-full",
  viewBox: "0 0 9 17"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M8.515 14.571c0 .891-1.077 1.337-1.707.707L.737 9.208a1 1 0 0 1 0-1.415l6.07-6.071c.63-.63 1.708-.184 1.708.707z"
    }, null, -1)
  ])))
}
export default { render: render }